import { toast } from "react-toastify";
import React from "react";
import { useLocation } from "react-router-dom";
import M from "materialize-css";

export const roundToThreeDecimal = (num) => {
  return Math.round(num * 1000) / 1000;
};

export const handleError = (error) => {
  toast.error(error.response ? error.response?.data : error.message);
};

// const daysOfWeek = [
//   "Sunday",
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
// ];
const monthsOfYear = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getCurrentDateTime = (dateString) => {
  const date = new Date(dateString);
  const month = monthsOfYear[date.getUTCMonth()];
  const year = date.getFullYear();
  const dayOfMonth = date.getUTCDate();
  const formattedDate = `${month} ${dayOfMonth} ${year} `;
  return formattedDate;
};

export function calculateRemainingTime(endTime) {
  if (!endTime) return 0;
  const now = new Date().getTime();
  const end = new Date(endTime).getTime();
  return Math.max(end - now, 0);
}

export const checkApprovedCatalogue = (catelogueStatus) => {
  if (catelogueStatus === "approval") {
    return false;
  } else {
    return true;
  }
};

export const formatTime = (milliseconds) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

export const NumberFormatter = (number) => {
  if (!number) return 0;
  const formattedNumber = new Intl.NumberFormat("en-IN").format(number);

  return <div>{formattedNumber}</div>;
};

export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function notify(msg, bg) {
  M.toast({ html: msg, classes: `${bg ? bg : ""}` });
}

let sessionExpiredNotified = false;

export async function notifyError(msg, status = false) {
  if (status === 498 || status === 401) {
    if (!sessionExpiredNotified) {
      try {
        localStorage.removeItem("auction-client");
        sessionExpiredNotified = true;
        // toast.error("Session expired. Please log in again.", {
        //   hideProgressBar: true,
        //   autoClose: 2000,
        // });

        window.location.href = "/login";
        return;
      } catch (error) {
        console.error("Error handling session expiration:", error);
      }
    }
    return;
  }
  document.body.style.overflow = "auto";
  toast.error(msg, {
    hideProgressBar: true,
    autoClose: 2000,
  });
}

export function notifySuccess(msg) {
  document.body.style.overflow = "auto";
  toast.success(msg, {
    // position: toast.POSITION.BOTTOM_LEFT,
    hideProgressBar: true,
    autoClose: 2000,
  });
}

export function formatFileSize(bytes) {
  if (bytes >= 1024 * 1024) {
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  } else {
    return (bytes / 1024).toFixed(2) + " KB";
  }
}

export const catalogueStatus = (status) => {
  if (!status) return "Not Upload";
  else if (status === "approval") {
    return "Approval";
  } else if (status === "notApproval") {
    return "Not Approval";
  } else {
    return "Pending";
  }
};

export const handleDateSetUp = (dates) => {
  if (!dates) return "";

  const date = dates.split("T")[0];
  const [year, month, day] = date.split("-");

  return `${day}-${month}-${year}`;
};

export function convertTo12HourFormat(time) {
  if (!time) return "";

  return new Date(time)
    .toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour12: true,
      hour: "numeric",
      minute: "numeric",
    })
    .toUpperCase();
}

export function convertToIST12HourFormat(utcTimestamp) {
  if (!utcTimestamp || isNaN(Date.parse(utcTimestamp))) {
    return "00:00:00";
  }

  const time = new Date(utcTimestamp).toLocaleString("en-US", {});
  const timePart = time?.split(" ");

  return `${timePart[1]}  ${timePart[2]}`;
}

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function NoItemsLeftInTable({ height = false }) {
  return (
    <span
      className="valign-wrapper justify-center noItems-height font-25 black-text"
      style={{ height: height ? height : "300px" }}
    >
      No items Available ...
    </span>
  );
}

export function checkCorrectLocationFiled(addressCollection) {
  if (!addressCollection.location.address.trim()) {
    notifyError("Address is required");
    return true;
  }

  if (!addressCollection.location.state.trim()) {
    notifyError("State is required");
    return true;
  }

  if (!addressCollection.location.city.trim()) {
    notifyError("City is required");
    return true;
  }

  if (!addressCollection.location.country.trim()) {
    notifyError("Country is required");
    return true;
  }
  if (
    isNaN(addressCollection.location.longitude) ||
    isNaN(addressCollection.location.latitude)
  ) {
    notifyError("Longitude and latitude must be a number");
    return true;
  }
  return false;
}

export const truncateText = (text, maxLength) => {
  if (!text) return "";
  if (text?.length <= maxLength) {
    return text;
  }
  return text?.substring(0, maxLength) + "...";
};

export function getTotalPages(arrayLength, numberOfRow) {
  return Math.ceil(arrayLength / numberOfRow);
}
export const handlePageClick = (event, setCurrentPage, numberOfRow) => {
  setCurrentPage(event.selected * numberOfRow);
};

const currentDate = new Date();
export const isToday = (givenDate) => {
  return (
    currentDate.getFullYear() === givenDate.getFullYear() &&
    currentDate.getMonth() === givenDate.getMonth() &&
    currentDate.getDate() === givenDate.getDate()
  );
};

export const currentTime = () => {
  return new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const getTimeFromdate = (date) => {
  const dateObj = new Date(date);

  const hours = dateObj.getHours().toString().padStart(2, "0");
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const seconds = dateObj.getSeconds().toString().padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

export const currentTimeWithoutSecond = () => {
  return new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const convertDateIntoDayMonthOrRelativeTime = (dateStr) => {
  const date = new Date(dateStr);
  const currentTime = new Date();

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });

  const timeDifference = currentTime - date;
  const timeDifferenceInHours = timeDifference / (1000 * 60 * 60);

  const isToday = currentTime.toDateString() === date.toDateString();
  if (isToday) {
    if (timeDifferenceInHours <= 8) {
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } else {
      return "Today";
    }
  }

  // Check if the date was yesterday
  const yesterday = new Date(currentTime);
  yesterday.setDate(currentTime.getDate() - 1);
  const isYesterday = yesterday.toDateString() === date.toDateString();
  if (isYesterday) {
    return "Yesterday";
  }

  // For all other dates, return day and month name
  return `${day} ${month}`;
};

export const formatDate = (date) => {
  if (!date) return "";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};

export function getFormattedDate(dates, gaps) {
  const date = dates;
  date.setDate(date.getDate() + gaps);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

export const auctionTypeStyle = (type) => {
  if (type === "reverseAuctionService") {
    return "Reverse Service Auction";
  }
  else if (type === "reverseAuctionProduct") {
    return "Reverse Product Auction";
  } else {
    return "Forward Auction";
  }
};

export const capitalizeEveryFirstLetter = (str) => {
  return str?.split(" ")?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())?.join(" ");
};

export function formatRole(role) {
  if (!role) return '';
  let formatted = role.replace(/_/g, ' ');

  formatted = formatted
    .split(' ')
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(' ');

  return formatted;
}

export const formate24hrsTo12hrs = (time) => {
  if (time) {
    const [hours, minutes] = time?.split(":");

    let hoursNum = parseInt(hours);
    const period = hoursNum >= 12 ? "PM" : "AM";
    hoursNum = hoursNum % 12 || 12;
    const hoursFormatted = String(hoursNum).padStart(2, "0");

    return `${hoursFormatted}:${minutes} ${period}`;
  } else {
    return time;
  }
};
